import { app } from '../../../../app';
app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-computers', {
        url: '/reports/computers',
        component: 'companyComputersReport',
        resolve: {
        	computersProtectionApplications,
        }
    });
}

/** @ngInject */
function computersProtectionApplications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllComputerProtectionApplicationsForCompany(companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/computers-report/computers-report.state.js